import React, { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
// Imported from the module, not the `features/auth` barrel: the barrel re-exports
// a `.jsx` file, which jest's transform does not cover.
import { ProtectedRoute } from '../auth/components/ProtectedRoute';
import { SUBAGENTS_PERMISSIONS } from './permissions';
import { SUBAGENTS_ROUTE_SEGMENT } from './constants';
import { SubagentsSkeleton } from './components/SubagentsSkeleton/SubagentsSkeleton';

// Points at the page module, not the feature barrel, so importing this file from
// AppRouter does not pull the feature into the main bundle. While the chunk
// loads, the route draws the catalogue's own skeleton (VOX-389), not the app's
// generic one.
const SubagentsPage = lazy(() =>
  import('./pages/SubagentsPage/SubagentsPage').then((module) => ({
    default: module.SubagentsPage,
  })),
);

/**
 * Route of the Subagents module (VOX-329), mounted by AppRouter under the agent's
 * `myassistant` routes, next to `campaigns`.
 *
 * A `Route` element and not a component: `<Routes>` only accepts `Route`
 * children, and a wrapper component would break routing silently.
 *
 * Gated like Campaigns (see `permissions.ts`). The module card only shows with
 * Phone Voice Outbound configured; the route itself is not gated on it, same as
 * `campaigns`, whose list answers 409 on its own when Outbound is missing.
 */
export const subagentsRoutes = (
  <Route
    path={SUBAGENTS_ROUTE_SEGMENT}
    element={
      <ProtectedRoute requiredPermission={SUBAGENTS_PERMISSIONS.view}>
        <Suspense fallback={<SubagentsSkeleton />}>
          <SubagentsPage />
        </Suspense>
      </ProtectedRoute>
    }
  />
);
